import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/floresville")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Floresville, TX | Texas Made Shade",
      description: "Custom welded awnings, sail shades, patio & pergola covers, marine canvas and aluminum fabrication for Floresville & Wilson County.",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Floresville, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Floresville and Wilson County.",
      keywords: "awnings Floresville, awning company Floresville, custom awnings Floresville, sail shades Floresville, patio covers Floresville, pergola covers Floresville, metal awnings Floresville, canvas awnings Floresville, Texas Made Shade",
    }),
    scripts: cityHeadScripts("Floresville", "Wilson County"),
  }),
  component: () => <CityHomePage city="Floresville" region="Wilson County" />,
});
